const svg = `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="560"
  height="430"
  viewBox="0 0 560 430"
>
  <title>
    Full-screen fulfillment with rearrangeable Items, Notes, and Payment
    information
  </title>
  <rect width="560" height="430" rx="16" fill="#202323" />
  <rect x="18" y="18" width="524" height="394" rx="10" fill="#fafafa" />
  <path d="M28 18H532Q542 18 542 28V62H18V28Q18 18 28 18Z" fill="#fff" />
  <path d="M18 62H542" stroke="#d3d7d7" />
  <g>
    <text
      x="36"
      y="48"
      font-family="Arial"
      font-size="17"
      font-weight="bold"
      fill="#202323"
    >
      ← Fulfillment #1001
    </text>
    <g>
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;0 0;0 204;0 204;0 0;0 0"
        keyTimes="0;.12;.28;.66;.78;1"
        dur="9s"
        repeatCount="indefinite"
      />
      <rect
        x="34"
        y="68"
        width="370"
        height="90"
        rx="7"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text
        x="48"
        y="93"
        font-family="Arial"
        font-size="16"
        font-weight="bold"
        fill="#303535"
      >
        ⠿ Items
      </text>
      <text x="48" y="120" font-family="Arial" font-size="13" fill="#687070">
        Classic Tee · Medium / Navy · $25.00
      </text>
      <rect x="48" y="134" width="180" height="7" rx="3" fill="#e6e8e8" />
    </g>
    <g>
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;0 0;0 -102;0 -102;0 0;0 0"
        keyTimes="0;.12;.28;.66;.78;1"
        dur="9s"
        repeatCount="indefinite"
      />
      <rect
        x="34"
        y="170"
        width="370"
        height="90"
        rx="7"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text
        x="48"
        y="195"
        font-family="Arial"
        font-size="16"
        font-weight="bold"
        fill="#303535"
      >
        ⠿ Notes
      </text>
      <text x="48" y="222" font-family="Arial" font-size="13" fill="#687070">
        Please leave at the front door.
      </text>
      <rect x="48" y="236" width="180" height="7" rx="3" fill="#e6e8e8" />
    </g>
    <g>
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;0 0;0 -102;0 -102;0 0;0 0"
        keyTimes="0;.12;.28;.66;.78;1"
        dur="9s"
        repeatCount="indefinite"
      />
      <rect
        x="34"
        y="272"
        width="370"
        height="90"
        rx="7"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text
        x="48"
        y="297"
        font-family="Arial"
        font-size="16"
        font-weight="bold"
        fill="#303535"
      >
        ⠿ Payment information
      </text>
      <text x="48" y="324" font-family="Arial" font-size="13" fill="#687070">
        Products $25.00   ·   Total $25.00
      </text>
      <rect x="48" y="338" width="180" height="7" rx="3" fill="#e6e8e8" />
    </g>
  </g>
  <g aria-label="Fulfillment sidebar">
    <path d="M418 62H542V402H418Z" fill="#fff" />
    <path d="M418 62V402" stroke="#d3d7d7" />

    <rect x="430" y="74" width="100" height="28" rx="5" fill="#303535" />
    <text
      x="480"
      y="92"
      text-anchor="middle"
      font-family="Arial"
      font-size="11"
      fill="#fff"
    >
      Mark as fulfilled
    </text>
    <g>
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;0 0;0 116;0 116;0 0;0 0"
        keyTimes="0;.42;.58;.84;.96;1"
        dur="9s"
        repeatCount="indefinite"
      />
      <rect
        x="418"
        y="118"
        width="124"
        height="116"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text
        x="434"
        y="137"
        font-family="Arial"
        font-size="12"
        font-weight="bold"
        fill="#303535"
      >
        ⠿ Shipping
      </text>
      <text x="434" y="157" font-family="Arial" font-size="11" fill="#687070">
        Address
      </text>
      <rect x="434" y="166" width="84" height="6" rx="3" fill="#d3d7d7" />
      <rect x="434" y="178" width="62" height="6" rx="3" fill="#d3d7d7" />
      <text x="434" y="205" font-family="Arial" font-size="11" fill="#687070">
        Service: Standard
      </text>
    </g>
    <g>
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;0 0;0 -116;0 -116;0 0;0 0"
        keyTimes="0;.42;.58;.84;.96;1"
        dur="9s"
        repeatCount="indefinite"
      />
      <rect
        x="418"
        y="234"
        width="124"
        height="116"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text
        x="434"
        y="254"
        font-family="Arial"
        font-size="12"
        font-weight="bold"
        fill="#303535"
      >
        ⠿ Packages
      </text>
      <rect
        x="434"
        y="267"
        width="92"
        height="42"
        rx="5"
        fill="#fff"
        stroke="#d3d7d7"
      />
      <text x="442" y="285" font-family="Arial" font-size="11" fill="#687070">
        Standard box
      </text>
      <text x="442" y="300" font-family="Arial" font-size="10" fill="#687070">
        15 oz
      </text>
    </g>
  </g>
</svg>`;

export const shipmentDetailsWorkspaceAnimationUrl = `data:image/svg+xml,${encodeURIComponent(svg)}`;
